import { QueryClient } from "@tanstack/react-query";

// Single app-wide React Query cache. Conservative defaults; reference-data
// hooks (categories, mediums, …) override staleTime to ~1h since that data
// rarely changes. refetchOnWindowFocus is off so a marketplace tab regaining
// focus doesn't trigger a wave of background refetches.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
